<template>
  <div
    class="validation-container"
    :class="{
      'validation-visible': password.length > 0,
      'validation-hidden': password.length === 0,
    }"
  >
    <div v-if="password.length > 0">
      <ul class="validation-list">
        <li
          v-for="(message, key) in validationMessages"
          :key="key"
          :class="validations[key] ? 'validation-success' : 'validation-error'"
        >
          <span class="validation-icon" aria-hidden="true">{{
            validations[key] ? "✓" : "✗"
          }}</span>
          <span class="sr-only">{{
            validations[key] ? "Requirement met - " : "Requirement not met - "
          }}</span>
          <span v-html="message"></span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";
defineProps({
  password: {
    type: String,
    required: true,
  },
  validations: {
    type: Object,
    required: true,
    default: () => ({
      lowercase: false,
      uppercase: false,
      specialChar: false,
      length: false,
    }),
  },
});

const validationMessages = {
  lowercase: "Must contain at least <b>one lowercase letter</b>",
  uppercase: "Must contain at least <b>one capital letter</b>",
  specialChar:
    "Must contain at least <b>one special letter (e.g. $, %, &...)</b>",
  length: "Must be at least <b>10 characters in length</b>",
};
</script>

<style scoped>
.validation-container {
  overflow: hidden;
  font-size: 0.875rem;
  width: 100%;
  transition: all 0.5s ease-in-out;
  max-height: 0;
  opacity: 0;
}

.validation-visible {
  opacity: 1;
  max-height: 200px;
}

.validation-hidden {
  opacity: 0;
  max-height: 0;
  overflow: hidden;
  display: none;
}

.validation-list {
  list-style-type: none;
  margin: 0;
  text-align: left;
  padding: 0;
}

.validation-list li {
  margin-bottom: 0.25rem;
  font-size: var(--fs-small);
}

.validation-success {
  color: #10b981; /* text-green-500 */
}

.validation-error {
  color: #ef4444; /* text-red-500 */
}

.validation-icon {
  display: inline-block;
  width: 1.25rem;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
</style>
